import { FC, SVGProps } from "react";

const EditIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg enableBackground="new 0 0 512 512" height="512" viewBox="0 0 512 512" fill="currentcolor" width="512" {...props}>
      <g>
        <path d="m458.427 130.696c23.451-23.451 23.447-61.404 0-84.853l-28.284-28.284c-23.395-23.394-61.459-23.394-84.854 0l-263.986 263.987c-15.199 15.199-25.244 35.289-28.284 56.568l-14.143 98.995 98.996-14.142c21.278-3.04 41.368-13.085 56.567-28.284zm-325.27 155.564 169.706-169.706 56.568 56.568-169.705 169.706zm-47.14 103.709 6.6-46.197c1.509-10.56 5.9-20.626 12.53-28.954l56.022 56.021c-8.327 6.631-18.393 11.022-28.953 12.531zm344.126-287.558-42.427 42.427-56.568-56.568 42.426-42.426c7.797-7.798 20.486-7.798 28.283 0l28.284 28.284c7.819 7.818 7.816 20.47.002 28.283z" />
        <path d="m0 471.986h512v40h-512z" />
      </g>
    </svg>
  );
};

export default EditIcon;
